import './PracticeExams.sass';

import React from 'react';
import { Col, Modal, Row } from 'react-bootstrap';

import Spinner from '../../../commonComponents/Spinner/Spinner';
import SubHeader from '../../../commonComponents/SubHeader/SubHeader';
import {
  FIXED_DUTY_STATE,
  VALID_RANKS,
} from '../../../constants/examConstants';
import { canPerformAction } from '../../../utilities/permissionUtils';
import { sanitizeRichText } from '../../../utilities/reRenderFormulas';

const MAX_AMOUNT_QUESTIONS = 1000;
const MAX_EXAM_TIME_IN_MINUTES = 600;
const DEFAULT_AMOUNT_QUESTIONS = 175;
const DEFAULT_EXAM_TIME_IN_MINUTES = 180;

export default class PracticeExams extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      options: this.props.options,
      requestSent: false,
      internalQueryError: false,
      search: '',
      rateId: null,
      dutyState: null,
      rank: null,
      questionToDelete: null,
      activateModalOpen: false,
      scrolled: false,
      questionUpdateMessage: true,
      questionsViewScrolled: false,
      amountQuestions: '',
      examTime: '',
      numberErrors: {
        questions: null,
        time: null,
      },
    };
  }

  // REACT LIFECYCLE FUNCTIONS
  componentDidMount() {
    this.props.loadRates();
    this.checkScrollStatus();
    this.props.setBuildAllExamsWaiting(true);
    this.props.setBuildAllExamsProgress(0);
    this.props.setBuildAllExamsSuccess(false);
    this.props.checkBuildPEProgress();
  }

  showQuestionUpdateMessage = () => {
    this.setState({ questionUpdateMessage: false });
    setTimeout(() => {
      this.setState({ questionUpdateMessage: true });
    }, 2500);
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.removeQuestionSuccess) {
      this.openDeleteQuestionModal(null);
      this.props.setRemoveQuestionSuccess(false);
      this.showQuestionUpdateMessage();
      this.setState({ questionsViewScrolled: true });
    }
    if (nextProps.activateExamSuccess) {
      this.openActivateExamModal(false);
      this.props.setActivateExamSuccess(false);
    }
    if (nextProps.buildAllExamsSuccess) {
      this.props.setBuildAllExamsSuccess(false);
    }
  }

  componentDidUpdate(prevProps) {
    this.checkScrollStatus();
    if (
      prevProps.exam !== this.props.exam ||
      prevProps.practiceExams !== this.props.practiceExams ||
      prevProps.ratingExamId !== this.props.ratingExamId
    ) {
      const selectedExam = this.getSelectedExam();

      if (selectedExam) {
        this.setState({
          amountQuestions: selectedExam.amountQuestions ?? '',
          examTime: selectedExam.examTimeInMillis
            ? selectedExam.examTimeInMillis / (1000 * 60)
            : '',
        });
      } else if (this.props.ratingExamId) {
        this.setState({
          amountQuestions: DEFAULT_AMOUNT_QUESTIONS,
          examTime: DEFAULT_EXAM_TIME_IN_MINUTES,
        });
      }
    }
  }

  getSelectedExam = () => {
    const { practiceExams, exam } = this.props;

    if (!Array.isArray(practiceExams) || !practiceExams.length) return null;

    return (
      practiceExams.find((practiceExam) => practiceExam.id === exam) ||
      practiceExams[0]
    );
  };

  checkScrollStatus = () => {
    if (!this.state.scrolled) {
      const ratesContainer = document.querySelector('.rates-container');
      if (ratesContainer) {
        const activeRow = document.querySelector('.active-row');
        if (activeRow) {
          ratesContainer.scrollTop =
            activeRow.parentNode.parentNode.offsetTop - 200;
          this.setState({ scrolled: true });
        }
      }
    }
  };

  onSearch = (event) => {
    this.setState({ search: event.target.value });
  };

  clearSearchInput = () => {
    this.setState({ search: '' });
  };

  selectOption = (rateId, rank, dutyState, practiceExamId) => {
    this.props.checkBuildPEProgress();
    this.props.selectOption(rateId, rank, dutyState);
    this.props.loadPracticeExamInformation(
      rateId,
      rank,
      dutyState,
      practiceExamId,
    );
  };

  getRates = () => {
    let { rates } = this.props;

    // search filter
    if (this.state.search !== '') {
      const search = this.state.search.toLowerCase();
      rates = rates.filter((r) => {
        if (r.id !== 0) {
          return (
            r.name.toLowerCase().includes(search) ||
            r.shortname.toLowerCase().includes(search)
          );
        }
        return null;
      });
    }

    if (rates.length > 0) {
      if (rates[0].id === 0) {
        rates.shift();
      }

      return rates.map((rate, index) => (
        <RateLine
          key={`${rate.shortname}${index}`}
          rate={rate}
          selectOption={this.selectOption}
          selectedDutyState={this.props.dutyState}
          selectedRate={this.props.rate}
          selectedRank={this.props.rank}
        />
      ));
    }
    return <p>No AFSCs loaded</p>;
  };

  buildAllExams = (questions, time, rebuildAll) => {
    const { rates } = this.props;

    const ratesList = rates.filter((r) => r.id !== 0).map((r) => r.id);

    if (ratesList.length > 0) {
      this.props.buildAllExams({ ratesList, questions, time, rebuildAll });
    }
  };

  renderRatingExamsList = () => {
    const { permissions = [] } = this.props;
    const canBuild = canPerformAction('PracticeExams.Build', permissions);

    return (
      <Col md={3} className="practice-exams-group-list px-0">
        <SubHeader
          options={['Practice Exams']}
          onOptionChange={() => {}}
          activeOption="Practice Exams"
          onSearch={this.onSearch}
          onPlusClick={null}
          disabledOptions={[]}
          searchValue={this.state.search}
          clearSearchInput={this.clearSearchInput}
          pePage
          buildAllExams={canBuild ? this.buildAllExams : undefined}
          buildAllExamsWaiting={this.props.buildAllExamsWaiting}
          fromPracticeExam
        />
        <div className="rates-container">{this.getRates()}</div>
      </Col>
    );
  };

  renderExamsSelector = () => {
    const { practiceExams, exam } = this.props;

    return (
      <select
        id="examSelector"
        className="form-control exam-selector"
        value={exam || ''}
        onChange={(e) => this.handleExamChange(e.target.value)}
      >
        {practiceExams.map((practiceExam) => (
          <option value={practiceExam.id} key={practiceExam.id}>
            {practiceExam.name}
            {practiceExam.enabled ? '' : ' (not active)'}
          </option>
        ))}
      </select>
    );
  };

  /**
   * Exams Settings means amount of questions and exam time
   * which are customizable on PW
   */
  getExamSettings = () => {
    const { amountQuestions, examTime } = this.state;
    const numberErrors = { questions: null, time: null };

    const questions = amountQuestions === '' ? null : Number(amountQuestions);
    const time = examTime === '' ? null : Number(examTime);

    if (
      questions !== null &&
      (!Number.isFinite(questions) ||
        questions <= 0 ||
        questions >= MAX_AMOUNT_QUESTIONS)
    ) {
      numberErrors.questions = `Question amount should be greater than 0 and less than ${MAX_AMOUNT_QUESTIONS}`;
    }

    if (
      time !== null &&
      (!Number.isFinite(time) || time <= 0 || time >= MAX_EXAM_TIME_IN_MINUTES)
    ) {
      numberErrors.time = `Time value should be greater than 0 and less than ${MAX_EXAM_TIME_IN_MINUTES}`;
    }

    this.setState({ numberErrors });

    if (numberErrors.questions || numberErrors.time) return null;

    return { questions, time };
  };

  handleBuildButtonPress = (practiceExamId) => {
    const settings = this.getExamSettings();

    if (!settings) return;

    this.props.buildPracticeExam(
      practiceExamId,
      settings.questions,
      settings.time,
    );
  };

  handleCreateButtonPress = () => {
    const settings = this.getExamSettings();

    if (!settings) return;

    this.props.createPracticeExam(
      this.props.ratingExamId,
      settings.questions,
      settings.time,
    );
  };

  renderExamSettingsInputs = () => (
    <>
      <div className="inputWithlabel">
        <label htmlFor="amountOfQuestions"> Amount of questions:</label>
        <input
          id="amountOfQuestions"
          className="form-control exam-settings-input"
          type="number"
          value={this.state.amountQuestions}
          placeholder="Amount of questions"
          onChange={(e) => this.setState({ amountQuestions: e.target.value })}
        />
        {this.state.numberErrors.questions && (
          <small style={{ color: 'red' }}>
            {this.state.numberErrors.questions}
          </small>
        )}
      </div>
      <div className="inputWithlabel">
        <label htmlFor="examTime"> Exam time (mins):</label>
        <input
          id="examTime"
          className="form-control exam-settings-input"
          type="number"
          value={this.state.examTime}
          placeholder="Exam time (minutes)"
          onChange={(e) => this.setState({ examTime: e.target.value })}
        />
        {this.state.numberErrors.time && (
          <small style={{ color: 'red' }}>{this.state.numberErrors.time}</small>
        )}
      </div>
    </>
  );

  handleExamChange = (examId) => {
    const { rate, rank, dutyState } = this.props;
    this.selectOption(rate, rank, dutyState, Number(examId));
  };

  openDeleteQuestionModal = (questionId) => {
    this.setState({ questionToDelete: questionId });
  };

  openActivateExamModal = (value) => {
    this.setState({ activateModalOpen: value });
  };

  renderQuestionsContent = () => {
    const { permissions = [] } = this.props;
    const canDeleteQuestion = canPerformAction(
      'PracticeExams.DeleteQuestion',
      permissions,
    );

    const { questions, newQuestion } = this.props;

    if (this.state.questionsViewScrolled && newQuestion) {
      const scrollTo = document.getElementById(String(newQuestion));
      if (scrollTo) {
        scrollTo.scrollIntoView();
      }
    }

    if (questions.length === 0) {
      return (
        <div className="no-questions-message">
          This exam has not questions yet. Press BUILD to start.
        </div>
      );
    }
    return questions.map((question, index) => (
      <div key={`%${question.id}-${index}`} className="question-detail">
        <div id={question.id} className="detail-header">
          {`Question: ${question.id}`}
          {question.id !== newQuestion ? (
            ' '
          ) : this.state.questionUpdateMessage ? (
            <sapn className="font-weight-bold ml-2 question-updated">
              {' '}
              Question Updated{' '}
            </sapn>
          ) : (
            <sapn className="font-weight-bold ml-2 question-updated question-updated-visible">
              {' '}
              Question Updated{' '}
            </sapn>
          )}
          {canDeleteQuestion && (
            <i
              className="fa fa-trash"
              onClick={() => this.openDeleteQuestionModal(question.id)}
            />
          )}
        </div>
        <div
          className="question-text"
          dangerouslySetInnerHTML={{
            __html: sanitizeRichText(question.text),
          }}
        />
      </div>
    ));
  };

  removeQuestion = (exam, questionToDelete) => {
    this.setState({ questionsViewScrolled: false });
    this.props.removeQuestion(exam, questionToDelete);
  };

  renderContent = () => {
    const {
      waiting,
      buildAllExamsWaiting,
      practiceExams,
      questions,
      exam,
      buildPracticeExamWaiting,
      removeQuestionWaiting,
      activateExam,
      activateExamWaiting,
      permissions = [],
    } = this.props;

    const canBuild = canPerformAction('PracticeExams.Build', permissions);

    if (waiting) {
      return (
        <div className="practice-exams-content">
          <Spinner text="Loading" className="loading-data-gif" />
        </div>
      );
    }
    if (buildAllExamsWaiting) {
      return (
        <div className="practice-exams-content">
          <Spinner
            text="The Practice Exams are being created in the background. You can close this tab."
            className="loading-data-gif"
          />
        </div>
      );
    }
    if (Array.isArray(practiceExams) && practiceExams.length !== 0) {
      const selectedExam = this.getSelectedExam();

      return (
        <div className="practice-exams-content">
          <Modal show={this.state.questionToDelete}>
            <div className="delete-question-modal-body">
              {!removeQuestionWaiting && this.state.questionToDelete && (
                <span>
                  Are you sure that you want to delete the following question:{' '}
                  {`${this.state.questionToDelete}?`}
                </span>
              )}
              {removeQuestionWaiting && (
                <span>
                  <Spinner
                    text={`Removing question: ${this.state.questionToDelete}`}
                  />
                </span>
              )}
              <div className="modal-buttons">
                <button
                  className="btn btn-danger delete-question-btn"
                  onClick={() =>
                    this.removeQuestion(exam, this.state.questionToDelete)
                  }
                >
                  DELETE
                </button>
                <button
                  className="btn btn-success delete-question-btn-cancel"
                  onClick={() => this.openDeleteQuestionModal(null)}
                >
                  CANCEL
                </button>
              </div>
            </div>
          </Modal>
          <Modal show={this.state.activateModalOpen}>
            <div className="delete-question-modal-body">
              {!activateExamWaiting && (
                <span>
                  Do you want to activate this exam? this action is
                  irreversible.
                </span>
              )}
              {activateExamWaiting && <Spinner />}
              <div className="modal-buttons">
                <button
                  className="btn btn-danger delete-question-btn"
                  onClick={() => activateExam(exam)}
                >
                  ACTIVATE
                </button>
                <button
                  className="btn btn-success delete-question-btn-cancel"
                  onClick={() => this.openActivateExamModal(false)}
                >
                  CANCEL
                </button>
              </div>
            </div>
          </Modal>
          {selectedExam && (
            <div className="top-bar">
              {/* EXAM SELECTOR: one weekly exam per date */}
              <div className="inputWithlabel">
                <label htmlFor="examSelector"> Exam:</label>
                {this.renderExamsSelector()}
              </div>
              {/* AMOUNT OF QUESTIONS AND TIME */}
              {this.renderExamSettingsInputs()}
              {/* BUILD / RE-BUILD BUTTON */}
              {canBuild && (
                <button
                  className="practice-exams-button btn btn-primary"
                  onClick={() => this.handleBuildButtonPress(selectedExam.id)}
                >
                  {questions.length === 0 ? 'BUILD' : 'RE-BUILD'}
                </button>
              )}
              {/* ACTIVATE BUTTON */}
              {questions.length > 0 && !selectedExam.enabled && (
                <button
                  className="practice-exams-button btn btn-danger"
                  onClick={() => this.openActivateExamModal(true)}
                >
                  ACTIVATE
                </button>
              )}
            </div>
          )}
          <div className="questions-content">
            {selectedExam &&
              !buildPracticeExamWaiting &&
              this.renderQuestionsContent()}
            {buildPracticeExamWaiting && <Spinner />}
          </div>
        </div>
      );
    }
    if (this.props.ratingExamId) {
      return (
        <div className="practice-exams-content">
          <div className="top-bar">
            {/* AMOUNT OF QUESTIONS AND TIME */}
            {this.renderExamSettingsInputs()}
            {canBuild && (
              <button
                className="practice-exams-button btn btn-primary"
                onClick={this.handleCreateButtonPress}
                disabled={buildPracticeExamWaiting}
              >
                CREATE
              </button>
            )}
          </div>
          <div className="no-questions-message">
            {buildPracticeExamWaiting ? (
              <Spinner text="Creating practice exam" />
            ) : (
              "This rating exam has no practice exams yet. Press CREATE to build this week's one."
            )}
          </div>
        </div>
      );
    }

    return (
      <div className="practice-exams-content">
        NO EXAMS FOUND FOR RATING EXAM
      </div>
    );
  };

  render() {
    return (
      <div className="practice-exams-component">
        {this.renderRatingExamsList()}
        {this.renderContent()}
      </div>
    );
  }
}

export class RateLine extends React.Component {
  state = {
    expanded: false,
  };

  componentWillReceiveProps(nextProps) {
    if (
      Number(nextProps.selectedRate) === Number(this.props.rate.id) &&
      !this.state.expanded
    ) {
      this.setState({ expanded: true });
    }
  }

  renderExpandIcon() {
    return (
      <div className="expand-icon-container">
        <i
          className={
            this.state.expanded
              ? 'fa fa-caret-down marginRight14'
              : 'fa fa-caret-right marginRight18'
          }
          aria-hidden="true"
        />
      </div>
    );
  }

  getDutyStateRowClass = (ds, rankId, rateId) => {
    const { selectedDutyState, selectedRank, selectedRate } = this.props;

    if (
      selectedDutyState === ds &&
      selectedRank === rankId &&
      rateId === selectedRate
    ) {
      return 'duty-state-row active-row';
    }
    return 'duty-state-row';
  };

  getRow = (rank) => {
    const { rate, selectOption } = this.props;
    return (
      <div className="rank-row">
        <Row
          className={`${this.getDutyStateRowClass(FIXED_DUTY_STATE, rank, rate.id)} pointer`}
          onClick={() => selectOption(rate.id, rank, FIXED_DUTY_STATE)}
        >
          <Col md={4} className="center-text">
            {rank}
          </Col>
        </Row>
      </div>
    );
  };

  getExpandedContent = () => (
    <div className="expanded-content-container">
      {VALID_RANKS.map((rank) => this.getRow(rank))}
    </div>
  );

  render() {
    const { rate } = this.props;
    return (
      <div className="group-list">
        <div
          className="group-row-hover"
          style={{ display: 'flex', alignItems: 'center' }}
          onClick={() => this.setState({ expanded: !this.state.expanded })}
        >
          {this.renderExpandIcon()}
          <div className="rate-name">
            <span className="rate-name-label">
              {rate.shortname ? `(${rate.shortname}) ${rate.name}` : rate.name}
            </span>
          </div>
        </div>
        {this.state.expanded && this.getExpandedContent()}
      </div>
    );
  }
}
